import { createClient } from "./utils";
import { ETH_MAINNET, SUPPORTED_CHAIN_IDS } from "config/chains";

export const chainlinkClient = createClient(ETH_MAINNET, "chainLink");

export function getGmxGraphClient(chainId: number, subgraph: string = "stats") {
  if (!SUPPORTED_CHAIN_IDS.includes(chainId)) {
    throw new Error(`Unsupported chain ${chainId}`);
  }

  return createClient(chainId, subgraph);
}
